import { useEffect } from 'react';
import { advantagesData } from '@/mocks/homeData';

export default function AdvantagesSection() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.advantages-animate');
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-20 md:py-32 bg-yakis-navy text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px',
        }} />
      </div>

      <div className="section-container relative z-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="advantages-animate animate-on-scroll mb-4">
            <span className="text-yakis-gold text-sm font-semibold tracking-wider uppercase">
              Por Qué Elegirnos
            </span>
          </div>
          <h2 className="advantages-animate animate-on-scroll font-display font-bold text-3xl sm:text-4xl md:text-5xl leading-tight mb-4">
            Ventajas que marcan
            <br />
            <span className="text-yakis-gold">la diferencia</span>
          </h2>
          <p className="advantages-animate animate-on-scroll text-white/60 text-base md:text-lg">
            Cada detalle de nuestro servicio está diseñado para superar las expectativas 
            de las empresas más exigentes de México.
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {advantagesData.map((item, index) => (
            <div
              key={item.id}
              className="advantages-animate animate-on-scroll group bg-white/5 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/10 transition-all duration-500 hover:bg-white/10 hover:border-yakis-gold/30 hover:-translate-y-1"
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-yakis-gold/20 text-yakis-gold mb-5 transition-all duration-300 group-hover:bg-yakis-gold group-hover:text-yakis-navy">
                <i className={`${item.icon} text-2xl`} />
              </div>

              {/* Title */}
              <h3 className="font-display font-semibold text-lg mb-3">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-white/60 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}